<template>
  <div class="pb-3 breadcrumb-truncate">
    <span>
      <slot name="home">
        <v-tooltip location="end" content-class="custom-tooltip-with-arrow">
          <template #activator="{ props }">
            <inertia-link href="/dashboard" class="dark:text-white text-gray-700" v-bind="props">
              <v-icon icon="mdi-monitor-dashboard"></v-icon>
            </inertia-link>
          </template>
          <span>Go to Dashboard.</span>
        </v-tooltip>
        <slot name="separator">
          <v-icon icon="mdi-chevron-right" class="transition dark:text-orange-400 text-red-500"></v-icon>
        </slot>
      </slot>
    </span>
    <span v-for="item, index in normalizedItems" :key="item.toString()">
      <slot name="icon"></slot>
      <v-tooltip :location="item.active ? 'top' : 'end'" content-class="custom-tooltip-with-arrow">
        <template #activator="{ props }">
          <inertia-link :href="item.link" v-bind="props" preserve-state preserve-scroll
            class="transition dark:text-gray-400 text-gray-800 hover:underline underline-offset-4">
            <div class="truncate decoration-red-500" :style="linkTextStyle"
              :class="item.active ? 'font-extrabold hover:overline' : 'font-extralight'">{{ item.title }}</div>
          </inertia-link>
        </template>
        <div v-if="item.active" class="text-center">
          <span class="text-center mb-0">{{ item.title }}</span><br>
          <span class="text-center my-0">You are here.</span>
        </div>
        <span v-else>Go back to {{ item.title }}.</span>
      </v-tooltip>

      <span v-if="index !== items.length -1">
        <slot name="separator">
          <v-icon icon="mdi-chevron-right" class="transition dark:text-orange-400 text-red-500"></v-icon>
        </slot>
      </span>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

  defineOptions({
    name: 'Breadcrumbs'
  })

  const props = defineProps({
    items: {
      type: Array,
      required: true
    }
  })


  const normalizedItems = computed(() => {
    let items = props.items
    items.map(item => {
      item.active = false
    })
    items[items.length - 1].active = true
    return items
  })

  const linkTextStyle = computed(() => {
    let numberOfItems = props.items.length
    let maxWidth = 100/numberOfItems
    if (numberOfItems > 2) {
      maxWidth = 100 / (numberOfItems + 2)
    }
    return {
      'max-width': `${maxWidth}vw`,
      'display': 'inline-flex'
    }
  })

</script>

<style>
.breadcrumb-truncate {
  overflow: hidden;
  white-space: nowrap;
  font-size: 0.6rem
}
</style>
